import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  public close() {
    this.element.remove();
  }
}
